<div class="row">
    <div class="col">
      <div class="card">
        <div class="card-header">
          <p class="card-title h4 float-left">{{ title }}</p>
          <button
            type="button"
            class="close float-right"
            aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="card-body">
          <form
            action=""
            [formGroup]="visitaForm"
            (ngSubmit)="registerVisita(visitaForm.value)"
            class="form-horizontal form-material"
            id="visitaform"
            novalidate
          >
            <div class="form-group m-t-20">
              <div class="col-xs-12">
                <app-form-error-wrapper
                  [control]="visitaForm.controls['fecha']"
                  [controlName]="'fecha'"
                >
                  <label for="fecha">Fecha de visita</label>
                  <input
                    class="form-control"
                    type="date"
                    id="fecha"
                    formControlName="fecha"
                    placeholder="Fecha"
                  />
                  
                </app-form-error-wrapper>
              </div>
            </div>
            <div class="form-group m-t-20">
              <div class="col-xs-12">
                <app-form-error-wrapper
                  [control]="visitaForm.controls['fecha']"
                  [controlName]="'fecha'"
                >
                  <label for="fecha">Hora de visita</label>
                  <input
                    class="form-control"
                    type="time"
                    id="time"
                    formControlName="hora"
                    placeholder="Hora"
                  />
                  
                </app-form-error-wrapper>
              </div>
            </div>
            <div class="form-group m-t-20">
              <div class="col-xs-12">
                <app-form-error-wrapper
                  [control]="visitaForm.controls['detalle']"
                  [controlName]="'detalle'"
                >
                  <label for="Detalle">Detalle</label>
                  <input
                    class="form-control"
                    type="text"
                    id="detalle"
                    formControlName="detalle"
                    placeholder="Detalle"
                  />
                </app-form-error-wrapper>
              </div>
            </div>
            <div class="form-group m-t-20">
              <div class="col-xs-12">
                <app-form-error-wrapper
                [control]="visitaForm.controls['cliente_id']"
                [controlName]="'cliente_id'"
              >
                <label for="Cliente">Cliente</label>
                <ng-select
                  bindLabel="nombres"
                  placeholder="Selecionar Cliente"
                  [searchable]="true"
                  formControlName="cliente_id"
                >
                  <ng-option>
                    Seleccionar todos
                  </ng-option>
                  <ng-option [value]="item" *ngFor="let item of cliente">
                    {{ item.nombres }} {{item.apellidos}}
                  </ng-option>
                </ng-select>
              </app-form-error-wrapper>
              </div>
            </div>
            <div class="form-group text-center m-t-20">
              <div class="col-xs-12">
                <button
                  class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                  [disabled]="visitaForm.invalid || isLoading"
                >
                  <app-button-loader
                    [isLoading]="isLoading"
                    [label]="'Agregar'"
                  ></app-button-loader>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>